import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAppNft } from '../store/appSlice';
import AntStats from './AntStats.js';
import BackButton from './BackButton';
import CenterContent from './CenterContent';
import StakeDiamond from './images/Icon_Diamond.png';
import ConfirmSelection from './ConfirmSelection.js';
import RewardInfo from './images/Icon_Reward_Info.png';
import CommonIMG from './images/Icon_Common.png';
import UncommonIMG from './images/Icon_Uncommon.png';
import RareIMG from './images/Icon_Rare.png';
import UltrareIMG from './images/Icon_Ultrarare.png';
import LegendaryIMG from './images/Icon_Legendary.png';
// Removed useWeb3 import
import Slider from 'react-slick';
import Tooltip from './Tooltip.js';
import PremiumAnt from './images/ANT.png'; // Assuming you have a default ANT image
import { useNft } from '../contexts/NftContext.js'; // Adjust the path as necessary
import diamond from './images/Icon_Diamond.png';
import earned from './images/Icon_Earned.png';

const tasksPoolIcons = [
  CommonIMG,
  UncommonIMG,
  RareIMG,
  UltrareIMG,
  LegendaryIMG
];

// Static data for offline demonstration
const staticAntNFTs = [
  {
    media: { mediaCollection: { high: { url: PremiumAnt } } },
    metadata: { image: PremiumAnt },
    maxPurseAmount: 3,
    level: 20,
    // Add other properties as needed
  },
  // Add more static ANTs
];

const staticTasksStakeInfo = {
  stakeFee: 50,
  tasksPoolsInfo: [
    { poolName: 'Common', levelRequired: 5, rewardAmount: 1 },
    { poolName: 'Uncommon', levelRequired: 10, rewardAmount: 2 },
    { poolName: 'Rare', levelRequired: 19, rewardAmount: 3 },
    { poolName: 'Ultrarare', levelRequired: 25, rewardAmount: 4 },
    { poolName: 'Legendary', levelRequired: 30, rewardAmount: 5 }
    // Add more pool info as needed
  ],
};


function TasksAssign({ goBack }) {
  const sliderRef = useRef();
  const { nfts } = useSelector(selectAppNft);
  const [activeItem, setActiveItem] = useState(null);
  const [selectedANTItem, setSelectedAntItem] = useState(null);
  const [showConfirmSelection, setShowConfirmSelection] = useState(false);
  const [antIndex, setANTIndex] = useState(0);

  const [antInfo, setAntInfo] = useState(undefined);
  const [imageUri, setImageUri] = useState(undefined);

  const antNFTs = staticAntNFTs;
  const tasksStakeInfo = staticTasksStakeInfo;

  useEffect(() => {
    console.log("selectedANTItem->", selectedANTItem);
  }, [selectedANTItem])

  const handleANTItemClick = (ant) => {
    setSelectedAntItem(ant); // Store the full ant information
    setImageUri(ant.metadata.image); // Store the image URI
    setActiveItem(ant.mint); // Highlight the active ANT
  };

  const handleSelectButtonClick = () => {
    setShowConfirmSelection(true);
  };

  const handleConfirmSelectionClose = () => {
    setShowConfirmSelection(false);
  };

  const resetSlider = () => {
    setANTIndex(0);
    sliderRef.current.slickGoTo(0, false)
  }

  const handleActiveNftChange = () => {
  };
  
  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      alert('Address copied to clipboard!');
    }, (err) => {
      console.error('Failed to copy address', err);
    });
  };

  const formatMint = (mint) => {
    if (!mint) return '';
    return `${mint.substring(0, 10)}...${mint.substring(mint.length - 10)}`;
  };

  const getProgressPercentage = () => {
    if (selectedANTItem && selectedANTItem.remainPotions !== undefined && selectedANTItem.level !== undefined) {
      return (selectedANTItem.remainPotions / (selectedANTItem.level + 1)) *100;
    }
    return 0;  // Default to 0 if data is not sufficient
  };

  const progressPercentage = getProgressPercentage();

  const getMaxChests = () => {
    if (!selectedANTItem) return 0;
    const suitableTask = tasksStakeInfo.tasksPoolsInfo
      .slice()
      .reverse()
      .find(pool => selectedANTItem.level >= pool.levelRequired);
    return suitableTask ? suitableTask.rewardAmount : 0;
  };

  return (
    <section id="nestwars-ants1">
      <div className="newui-container">
      <div className="platform-container">
        {/* <BackButton goBack={goBack} title="BACK TO BOSS FIGHTS" />
        <CenterContent onActiveNftChange={handleActiveNftChange} setAntInfo={setAntInfo} setImageUri={setImageUri} />
        <AntStats/> */}
        <div className="inventory-container">
        <div className="inventory-container-left">
          <BackButton goBack={goBack} title={"BACK TO TASKS"} />
          <div className="inventory-items">
            {nfts.map((nft, index) => {
              const isPremium = nft.type;
              return (
                <div
                  key={index}
                  className={`inventory-item ${isPremium ? "item-premium" : "item-basic"} ${activeItem === nft.mint ? "active9" : ""}`} // Highlight active Ant
                  onClick={() => handleANTItemClick(nft)}
                >
                  <img src={nft.metadata.image} alt={nft.metadata.image} />
                  <div className="inventory-item-texts">
                    <p className="inventory-text">{nft.metadata.name}</p>
                    <p className="inventory-level-text">LVL:</p>
                    <p className="inventory-text">{nft.level}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {showConfirmSelection && (
          <ConfirmSelection
            onClose={handleConfirmSelectionClose}
            antInfo={{ mint: selectedANTItem.mint }} // Pass only the required data
            stakeFee={50}
            assignType="tasks"
            imageUri = {imageUri}
          />
          // <button id="select-button" onClick={handleSelectButtonClick}>
          //   <span>SELECT</span>
          // </button>
        )}
        <div className="inventory-container-right">
          {selectedANTItem ? (
            <>
            <div className="boss-list">
                  <p className="boss-list-text">LIST OF TASKS</p>
                  {
                    tasksStakeInfo.tasksPoolsInfo.map((poolInfo, index) => {
                      return (
                        <div className={`container-right-data-holder ${selectedANTItem.level >= poolInfo.levelRequired ? 'active4' : ''}`} id="data-assign" key={index}>
                          <img src={tasksPoolIcons[index]} alt={poolInfo.poolName} />
                          <div className="rewards-text">
                            <span>LVL {poolInfo.levelRequired}</span><p>{poolInfo.poolName}</p><h3>{poolInfo.rewardAmount} CHESTS</h3>
                          </div>
                        </div>
                      )
                    })
                  }
                  </div>
              <div className="active-item-header-content-activity" id="ant-header-activity">
                <div className="inventory-item-active-activity antonright-activity"><img src={selectedANTItem.metadata?.image || PremiumAnt} alt={selectedANTItem.name}/></div>
                <div className="active-item-header-activity">
                  <h2>WORKER ANT</h2>
                  <p id="w-address" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(selectedANTItem.mint)}>{formatMint(selectedANTItem.mint)}</p>
                </div>
              </div>
              <div className="level-bar-container" id="level-bar-leveling">
              <div className="level-bar">
                <div className="level-indicator">
                LVL: <span className="bold-text">{selectedANTItem.level}</span>
                </div>
                <div className="exp-bar-container">
                  <div 
                    className="exp-bar" 
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
                <div className="exp-info">
                  EXP:<span className="bold-text"> {selectedANTItem.remainPotions}/{selectedANTItem.level+1}</span>
                </div>
              </div>
              </div>
              <div className="active-item-ant-container-activity2">
                    <div className="active-item-stats-activity-2">
                      <h2>MAX CHESTS</h2>
                      <img src={diamond} alt="diamond" />
                      <p>{getMaxChests()}</p>
                    </div>
                    <div className="active-item-stats-activity-2">
                      <h2>ENTRY FEE</h2>
                      <img src={earned} alt="earned" />
                      <p>{tasksStakeInfo.stakeFee} $ANTC</p>
                    </div>
                  </div>
          <div className="active-item-buttons-container-activity">
          <button className="active-item-button-lower" id="basic-ant-button-assign" onClick={handleSelectButtonClick}>ASSIGN ANT</button>
        </div>
            </>
          ) : (
            <h2 className="inventory-info-text">Choose an ANT to get more info</h2>
          )}
        </div>
        {showConfirmSelection && <ConfirmSelection 
        onClose={handleConfirmSelectionClose} 
        stakeFee={tasksStakeInfo.stakeFee} 
        antInfo={{ mint: selectedANTItem.mint }} 
        assignType="tasks" 
        imageUri={imageUri} 
        />}
        
        {!showConfirmSelection && (
          <button id="select-button" onClick={handleSelectButtonClick}>
            <span>SELECT</span>
          </button>
        )}
        {showConfirmSelection && <ConfirmSelection onClose={handleConfirmSelectionClose} stakeFee={tasksStakeInfo.stakeFee} antInfo={{ mint: selectedANTItem.mint }} assignType="tasks" imageUri={imageUri} />}
      </div>
      </div>
      </div>
    </section >
  );
}

export default TasksAssign;